import React from 'react';
import PropTypes from 'prop-types';

// The avatars come drawn by the server (VoicesHelper#voice_options), which
// keeps avataaars out of this pack. The playlist and the page each show a
// switcher, so each SVG is drawn twice: its ids get a suffix per switcher, or
// the mask="url(#...)" of the second would resolve in the first, which may be
// the hidden one.
const withOwnIds = (svg, suffix) => svg.replace(/( id="|url\(#|href="#)([^")]+)/g, `$1$2-${suffix}`);

class VoiceSwitcher extends React.Component {
  // In page, the switcher sits between "✏️ Avancement :" and "ℹ️ Mots donnés :"
  // on a white panel, so it borrows their grammar: an emoji, a bold label, a
  // colon, then the control. In the playlist it sits on the dark panel and
  // keeps its centred, dark styling.
  renderLabel() {
    if (!this.props.compact) {
      return <span className="text-grey text-base font-semibold mr-2">Voix de</span>;
    }

    return (
      <span className="font-bold mr-2">
        <span className="mr-1">🎙️</span> Voix de :
      </span>
    );
  }

  buttonClasses(selected) {
    const shape = this.props.compact ? 'pl-1 pr-3 py-1 text-sm' : 'pl-1 pr-3 py-1 text-base';

    if (this.props.compact) {
      return `${shape} ${selected ? 'bg-info text-white shadow' : 'text-black hover:bg-grey-light'}`;
    }

    return `${shape} ${selected ? 'bg-white text-black' : 'text-grey hover:text-white'}`;
  }

  render() {
    const compact = this.props.compact;

    return (
      <div className={`flex items-center ${compact ? '' : 'justify-center text-center mt-4'}`}>
        {this.renderLabel()}

        <div
          className={`inline-flex rounded-full ${compact ? 'bg-white border border-grey-light shadow-sm' : 'bg-black p-1'}`}
          role="group"
          aria-label="Choix de la voix"
        >
          { this.props.voices.map((voice, index) => {
            const selected = this.props.voice === voice.key;

            return (
              <button
                key={voice.key}
                type="button"
                aria-pressed={selected}
                disabled={this.props.loading}
                onClick={() => this.props.onChange(voice.key)}
                className={`flex items-center rounded-full font-semibold transition duration-100 ${index > 0 ? 'ml-1' : ''} ${this.buttonClasses(selected)}`}
              >
                <span
                  className={`${compact ? 'h-6 w-6' : 'h-8 w-8'} rounded-full bg-grey-light overflow-hidden inline-block align-middle mr-2 flex-shrink-0`}
                  dangerouslySetInnerHTML={{ __html: withOwnIds(voice.avatarSvg, compact ? 'page' : 'playlist') }}
                />
                {voice.label}
                { /* Below text-xs, the smallest step of the project's scale. */ }
                { voice.premium && <span className="ml-1" style={{ fontSize: compact ? '0.45rem' : '0.5rem' }}>✨</span> }
                { selected && this.props.loading && <i className="fas fa-spinner-third fa-spin ml-2" /> }
              </button>
            );
          }) }
        </div>
      </div>
    );
  }
}

VoiceSwitcher.propTypes = {
  voice: PropTypes.string.isRequired,
  voices: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  compact: PropTypes.bool
};

VoiceSwitcher.defaultProps = {
  loading: false,
  compact: false
};

export default VoiceSwitcher;
